var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-skeleton-loader",
    {
      attrs: {
        loading: _vm.isLoading,
        transition: "expand-transition",
        type: "article",
      },
    },
    [
      _c("FormJobListing", {
        attrs: {
          JobListing: _vm.editJobListing,
          isSaving: _vm.isSaving,
          addToFavourites: _vm.addToFavourites,
          mode: _vm.mode,
        },
        on: {
          "update:addToFavourites": function ($event) {
            _vm.addToFavourites = $event
          },
          "update:add-to-favourites": function ($event) {
            _vm.addToFavourites = $event
          },
          save: _vm.save,
          cancel: function ($event) {
            return _vm.$router.push({ name: _vm.from.name })
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }